module.exports = __webpack_public_path__ + "img/australia-leukaemia-female.7649e91e.png";